// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"V4-z","displaySixCardTiles":"W4-z"};